import { useEffect } from 'react';
import { useGame } from './store/game';
import { useOnline } from './store/online';
import { LOCAL_ONLY } from './lib/env';
import { GameScreen } from './game/GameScreen';
import { Home } from './screens/Home';
import { LocalSetup } from './screens/LocalSetup';
import { About } from './screens/About';
import { CreateRoom, JoinRoom } from './screens/OnlineForms';
import { Lobby } from './screens/Lobby';
import { S } from './theme';
import { art } from './art';
import { SoundControls } from './audio/SoundControls';
import { play, setMusicScene, unlockMusic } from './audio/sound';

function Logo() {
  return <img src={art.logoMark} alt="" />;
}

export function App() {
  const { screen, mode, go, leaveGame } = useGame();
  const phase = useGame((s) => s.view?.phase);
  const hasBoss = useGame((s) => !!s.view?.boss);

  // Trilha: tema de guerra no menu e na sala; batalha na partida (boss e fim de jogo via eventos).
  useEffect(() => {
    if (screen !== 'game') setMusicScene('menu');
    else setMusicScene(phase === 'over' ? 'over' : 'game', hasBoss);
  }, [screen, phase, hasBoss]);
  // O navegador só deixa tocar depois de uma interação.
  useEffect(() => {
    document.addEventListener('pointerdown', unlockMusic);
    return () => document.removeEventListener('pointerdown', unlockMusic);
  }, []);
  const onlineError = useOnline((s) => s.error);
  const onlineStatus = useOnline((s) => s.status);

  // Clique de interface em todo botão (o botão de mudo fica de fora).
  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      const b = (e.target as HTMLElement).closest('button');
      if (b && !b.disabled && !b.hasAttribute('data-silent')) play('click', { bus: 'ui' });
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);

  // Recarregou a aba no meio de uma sala: retoma com o token desta aba.
  useEffect(() => {
    if (!LOCAL_ONLY) useOnline.getState().resumeTab();
  }, []);

  const inGame = screen === 'game';
  return (
    <div className={`app${inGame ? ' in-game' : ''}`}>
      <header className="topbar">
        <button
          className="brand"
          onClick={() => {
            if (mode === 'local') leaveGame();
            else if (!inGame && screen !== 'lobby') go('home');
          }}
          title={mode === 'local' ? 'Voltar ao início (a partida fica salva)' : S.appTitle}
        >
          <Logo />
          {S.appTitle}
        </button>
        <span className="spacer" />
        <SoundControls />
        {mode === 'online' && onlineStatus !== 'open' && <span className="tag">{onlineError ?? 'reconectando…'}</span>}
        {!inGame && (
          <button className="btn ghost small" onClick={() => go('about')}>
            Regras e sobre
          </button>
        )}
      </header>
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        {screen === 'home' && <Home />}
        {screen === 'localSetup' && <LocalSetup />}
        {screen === 'about' && <About />}
        {screen === 'create' && <CreateRoom />}
        {screen === 'join' && <JoinRoom />}
        {screen === 'lobby' && <Lobby />}
        {screen === 'game' && <GameScreen />}
      </main>
      {!inGame && <footer className="footer">{S.disclaimer}</footer>}
    </div>
  );
}
